import ReferenceDataService from '@/services/referenceDataService';

const stateActions = {
  updateOrgConfiguration: async ({ dispatch, commit, getters, rootGetters }, { versionId, callback }) => {
    try {
      const loggedInAgent = rootGetters['AGENT/loggedInAgent'];
      const organizationData = await ReferenceDataService.getOrgConfiguration({ version: versionId });

      if (!organizationData.data.shortName) {
        organizationData.data.shortName =
          organizationData.data.orgAbbreviation || loggedInAgent.organizationData.shortName;
      }

      sessionStorage.setItem('organizationData', JSON.stringify(organizationData.data));

      commit('setOrganizationData', organizationData.data);
      commit('setOrganizationShortName', organizationData.data.shortName);
      dispatch('AGENT/updateTelephoneTerminals', { callback }, { root: true });
    } catch (e) {
      console.log(e);
    }
  },

  setOrganizationData: ({ commit }, organizationData) => {
    commit('setOrganizationData', organizationData);
  },

  setOrganizationShortName: ({ commit }, organizationShortName) => {
    commit('setOrganizationShortName', organizationShortName);
  },

  restoreOrganizationData: ({ commit }) => {
    const organizationData = JSON.parse(sessionStorage.getItem('organizationData'));
    commit('setOrganizationData', organizationData);
  },

  clearOrganizationData: ({ commit }) => {
    commit('setOrganizationData', {
      breakCategories: [],
      breakTypes: [],
      businessProcesses: [],
      dispositionCodeCategorySets: [],
      dispositionCodeCategorySetPerBP: {},
      enableIncomingCallRemoteAcceptOnPrimaryDevice: false
    });
  }
};

export default {
  ...stateActions
};
